<template>
  <div class="ltip-chart">
    <div class="header">
      <h3>Forecasted Total Plan Value*</h3>
      <!--      <div v-if="!clientIsDiy" class="legend-container">-->
      <!--        <div class="legend-wrap"><div class="legend-base" :style="`background-color:${clientColors.headerShade};`"></div>Base</div>-->
      <!--        <div class="legend-wrap"><div class="legend-target" :style="`background-color:${clientColors.header};`"></div>Target</div>-->
      <!--        <div class="legend-wrap"><div class="legend-superior" :style="`background-color:${clientColors.headerTint};`"></div>Superior</div>-->
      <!--      </div>-->
    </div>
    <div
      v-if="userDataLoaded"
      class="body"
    >
      <Line
        class="full-chart"
        :data="chartData"
        :options="chartOptions"
      />
      <Line
        class="mobile-chart"
        :data="mobileChartData"
        :options="chartOptions"
      />
    </div>
    <div class="mobile-chart-controls">
      <span
        class="prev-year"
        :class="{disabled:graph_year == 0}"
        @click="prevGraphYear"
      >&lt;</span>
      <span
        class="next-year"
        :class="{disabled:graph_year + 5 >= Math.min(history.length, 10)}"
        @click="nextGraphYear"
      >&gt;</span>
    </div>
    <div class="footer">
      <p style="font-size: 14px; text-align: center;">*Total Plan Value projections are based on a hypothetical forecast of future financial performance. This projection is not intended to provide guaranteed predictions of the future payment value of awards.</p>
    </div>
  </div>
</template>

<script>
import { Chart as ChartJS, LineController, LineElement, PointElement, LinearScale, CategoryScale } from 'chart.js';
import { Line } from 'vue-chartjs';
import UtilsMixin from "@/mixins/UtilsMixin";

ChartJS.register(LineController, LineElement, PointElement, LinearScale, CategoryScale);

export default {
  name: "LongTermLineChart",

  components: {
    Line
  },

  mixins: [ UtilsMixin ],

  props: {
    onlyTarget: {
      type: Boolean,
      default: false,
    },
    history: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      clientColors: {
        header: null,
        headerTint: null,
        headerShade: null,
      },
      graph_year: 0,
      chartData: {
        labels: [],
        datasets: [],
      },

      chartOptions: {
        devicePixelRatio: 4, // prevents blurry chart
        animation: false,
        maintainAspectRatio: false,
        layout: {
          padding: {
            bottom: 20
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            displayColors: false,
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += '$' + new Intl.NumberFormat().format(Math.round(context.parsed.y));
                }
                return label;
              }
            }
          }
        },
        elements: {
          point: {
            backgroundColor: this.headerColor(),
            radius: 7,
            hoverRadius: 7,
          },
          line: {
            borderColor: '#071820',
            borderWidth: 2,
            borderDash: [6, 4],
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return '$' + new Intl.NumberFormat().format(value);
              },
              padding: 10,
              font: {
                size: 16,
                weight: 'bold',
                family: 'Lexend Deca',
              },
              color: '#1F3A4D',
              minor: {
                display: true,
                },
            },
            border: {
              display: false,
            },
            grid: {
              color: '#cdd1d2',
            }
          },
          x: {
            grid: {
              display: false,
            },
            ticks: {
              font: {
                size: 16,
                weight: 'bold',
                family: 'Lexend Deca',
              },
              color: '#1F3A4D',
            },
          },
        },
      },
    }
  },

  computed: {
    userDataLoaded() {
      return this.$dataDirectory?.userDataLoaded
    },
    clientStyles() {
      if (this.userDataLoaded && this.$dataDirectory?.userData?.client_styles) return JSON.parse(this.$dataDirectory.userData.client_styles)
      else return null
    },
    mobileChartData() {
      return {
        labels: this.chartData.labels.slice(this.graph_year, this.graph_year + 5),
        datasets: [{
          data: this.chartData.datasets[0]?.data.slice(this.graph_year, this.graph_year + 5),
        }],
      }
    }
  },

  watch: {
    clientStyles: {
      handler: function () {
        this.getClientColors();
      },
      deep: true
    }
  },

  mounted() {
    this.getClientColors();
  },

  methods: {
    buildChartOptions() {
      this.chartOptions.elements.point.backgroundColor = this.headerColor();
    },

    buildChartData() {
      let current_history = this.history
      if(current_history.length > 10) current_history = current_history.slice((current_history.length - 10), current_history.length)

      this.chartData = {
        labels: [],
        datasets: [],
      }
      this.chartData.datasets.push({ data: [] })
      current_history.forEach((item) => {
        let value = item.target / 100

        this.chartData.labels.push(item.year)
        this.chartData.datasets[0].data.push(value)
      })

      // if(this.clientIsDiy) {
      //   this.chartData.push(['date', 'target', 'target', {'type': 'string', 'role': 'tooltip'}])
      //
      //   this.history.forEach((item) => {
      //     let value = item.target / 100
      //
      //     this.chartData.push([item.year, value, value, `Year: ${item.year}, Total Plan Value: ${value}`])
      //   })
      // }
      // else {
      //   this.chartData.push(['date', 'base', 'base', 'target', 'target', 'superior', 'superior'])
      //
      //   this.history.forEach((item) => {
      //     let base = item.base / 100
      //     let target = item.target / 100
      //     let superior = item.superior / 100
      //
      //     this.chartData.push([item.year, base, base, target, target, superior, superior])
      //   })
      // }
    },

    headerColor() {
      if(this.clientStyles && (
          typeof this.clientStyles.heading_background_red !== 'undefined' ||
          typeof this.clientStyles.heading_background_green !== 'undefined' ||
          typeof this.clientStyles.heading_background_blue !== 'undefined'
      )) {
        let r = this.clientStyles.heading_background_red
        let g = this.clientStyles.heading_background_green
        let b = this.clientStyles.heading_background_blue

        let color = this.RGBToHex(r, g, b)

        return `${color}`
      }
      return `#241b89`
    },
    headerTintColor() {
      if(this.clientStyles && (
          typeof this.clientStyles.heading_background_red !== 'undefined' ||
          typeof this.clientStyles.heading_background_green !== 'undefined' ||
          typeof this.clientStyles.heading_background_blue !== 'undefined'
      )) {
        let r = this.clientStyles.heading_background_red
        let g = this.clientStyles.heading_background_green
        let b = this.clientStyles.heading_background_blue

        let tint = this.RGBTint(r, g, b, 0.4)
        let color = this.RGBToHex(tint.r, tint.g, tint.b)

        return `${color}`
      }
      return `#8782be`
    },
    headerShadeColor() {
      if(this.clientStyles && (
          typeof this.clientStyles.heading_background_red !== 'undefined' ||
          typeof this.clientStyles.heading_background_green !== 'undefined' ||
          typeof this.clientStyles.heading_background_blue !== 'undefined'
      )) {
        let r = this.clientStyles.heading_background_red
        let g = this.clientStyles.heading_background_green
        let b = this.clientStyles.heading_background_blue

        let shade = this.RGBShade(r, g, b, 0.6)
        let color = this.RGBToHex(shade.r, shade.g, shade.b)

        return `${color}`
      }
      return `#64608d`
    },

    getClientColors() {
      this.clientColors.header = this.headerColor();
      this.clientColors.headerTint = this.headerTintColor();
      this.clientColors.headerShade = this.headerShadeColor();

      this.buildChartOptions();
      this.buildChartData();
    },
    prevGraphYear() {
      if (this.graph_year != 0) {
        this.graph_year--;
      }
    },
    nextGraphYear() {
      if (this.graph_year + 5 < Math.min(this.history.length, 10)) {
        this.graph_year++;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use "../../../../scss/variables";

.mobile-chart,
.mobile-chart-controls {
  display: none !important;
}
.ltip-chart {
  display: flex;
  flex-direction: column;
  height: 100%;

  .header {
    display: flex;
    justify-content: space-between;

    margin-bottom: 1rem;

    h3 {
      font-size: variables.$text-base;
      margin-left: 3rem;
    }
  }

  .footer {
    margin-top: 2rem;

    p {
      font-size: variables.$text-xs;
    }
  }

  .body {
    display: flex;

    flex-grow: 1;

    width: 100%;
    height: 100%;

    .chart {
      flex-grow: 1;

      width: 100%;
      height: 100%;
    }
  }
}

.legend-base {
  background-color: red;
}

.legend-target {
  background-color: blue;
}

.legend-superior {
  background-color: green;
}

.legend-base,
.legend-target,
.legend-superior {
  border-radius: 100%;
  height: 1rem;
  width: 1rem;

  margin-right: 0.4rem;
}

.legend-wrap {
  display: flex;
  align-items: center;

  margin-right: 1.5rem;
}

.legend-container {
  display: flex;

}

@media screen and (max-width: 600px) {
  .ltip-chart .body {
    height: 300px;
  }

  .full-chart {
    display: none !important;
  }

  .mobile-chart {
    display: unset !important;
  }

  .mobile-chart-controls {
    display: flex !important;
    justify-content: space-around;
  }
  
  span.next-year, span.prev-year {
    display: unset;
    text-decoration: underline;
    cursor: pointer;
    font-size: 24px;
    &.disabled {
      color: variables.$color-button-disabled;
      cursor: default;
    }
  }
}
</style>